import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { NotasFiscaisList } from './NotasFiscaisList'
import { NotaFiscalNova } from './NotaFiscalNova'

export function NotasFiscais() {
  return (
    <Switch>
      <Route exact path="/notas-fiscais" component={NotasFiscaisList} />
      <Route path="/notas-fiscais/nova" component={NotaFiscalNova} />
    </Switch>
  )
}
